import React, {Component, Children} from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Loader } from '../Templates';

export class PrivateRoute extends Component {

    showLoadingMessage() {
        // wating for process end (equal false)
        if(this.props.waitForProcess !== false) {
            return (
                <Loader />
            )
        }
    }

    redirectToLoginPage() {
        return (
            <Redirect to={{ pathname: '/login', state: { from: this.props.location } }} />
        )
    }

    redirectToVerify2faPage() {
        // TODO
    }

    isLoggedIn() {
        const {waitForProcess, loggedIn, children} = this.props;

        if((waitForProcess && waitForProcess !== false) || loggedIn === undefined) {
            return this.showLoadingMessage();
        } else if(!loggedIn) {
            return this.redirectToLoginPage();
        } else {
            return children;
        }
    }

    render () {
        const {path} = this.props
        return (
            <Route path={path} {...this.props}>
                {this.isLoggedIn()}
            </Route>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PrivateRoute/PrivateRoute.jsx